module.exports = __webpack_public_path__ + "img/product_xd_ng_1.bc913865.jpg";